import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Button,
    Card,
    CardBody,
    Col,
    Input, Label,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
} from 'reactstrap';
import i18n from '../../../i18next';

import DetailsCard from './orderDetailsCommon/DetailsCard';
import ConfirmationModal from './orderDetailsCommon/ConfirmationModal';
import OrderDetailsIcon from './orderDetailsCommon/OrderDetailsIcon';
import ProductsDetailsTable from './orderDetailsCommon/ProductsDetailsTable';
import OrderDetailsTable from './orderDetailsCommon/OrderDetailsTable';
import RefundHistoryTable from './orderDetailsCommon/RefundHistoryTable';
import {
    convertStringToBoolean,
    getMaxRefundAmount, getPriceWithCurrencySymbol,
    localizeCountryNames, renderOrderTypeSrc, renderPaymentTypeIcon,
    transformProductPrice, getMaxGiftCardsRefundAmount, getCurrencySymbol
} from '../../../utils/CommonUtils';
import { refund, refundGiftCard, cancelOrder, clearSelectedOrder, createTicket, resendFailedOrder, manuallyAcceptOrder, getOrdersDetails, addExtraTime, getOrderAsPdf, downloadOrderData, downloadPosOrderData } from '../../../actions/index';
import { CASH_ID, COLLECTION_ID, DELIVERY_ID, INSTORE_ID, REJECTED, ACCEPTED, US, CA, CURBSIDE_ID, MENUU_ADMIN, MENUU_MASTER_ADMIN, ACEPTADO } from '../../../utils/Constants';
import RestaurantUtils from '../../../utils/RestaurantUtils';
import { AvFeedback, AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import { GridLoader } from 'react-spinners';
import OrderSourceSelector from '../../common/OrderSourceSelector';
import MaterialIcon from 'material-icons-react';

class OrderDetailsScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            refundType: 'Full',
            refundValue: null,
            refundReason: '',
            cancelRefundReason: 'WE_ARE_TOO_BUSY',
            orderProblemDetails: "",
            isCancelOrderExpanded: false,
            rejectedOrderStatusReceived: null,
            resendOrderConfirmationModalOpened: false,
            acceptOrderConfirmationModalOpened: false,
            resetOrderId: null,
            acceptOrderId: null,
            loading: false,
            addExtraTime: false,
            extraTime: '5',
            cardId: '',
            giftCardTotalDiscount: null,
            refundGiftCardValue: null,
            giftCardRefundReason: '',
            refundedGiftCardValue: null
        }
        this.changeState = this.changeState.bind(this);
        this.toggle = this.toggle.bind(this);
        this.onClickAddExtraTime = this.onClickAddExtraTime.bind(this);
    }
    
    changeState({ target }) {
        const giftCards = this.props.orderDetails.order.paymentDetails ? this.props.orderDetails.order.paymentDetails.giftCards : null;
        if (target.name === 'refundType' && target.value === 'Full') {
            this.setState({ ...this.state, [target.name]: target.value, refundValue: '' });
        } else if(target.name === "cardId") {
            giftCards ? giftCards.map((giftCard, i) => {
                if(target.value === giftCard.cardId) {
                    this.setState({
                        [target.name]: target.value,
                        giftCardTotalDiscount: giftCard.amount,
                        refundedGiftCardValue: giftCard.refundAmount
                    })
                } else if(target.value === ''){
                    this.setState({
                        ...this.state,
                        [target.name]: target.value,
                        giftCardTotalDiscount: '',
                        refundGiftCardValue: '',
                        refundedGiftCardValue: '',
                        giftCardRefundReason: ''
                    });
                }
            }) : null
        } else {
            this.setState({ ...this.state, [target.name]: target.value });
        }
    }

    toggle() {
        this.props.onToggle();
        this.props.clearSelectedOrder();
        this.resetState();
    }

    resetState() {
        this.state.refundType = 'Full';
        this.state.refundValue = null;
        this.state.refundReason = '';
        this.state.cancelRefundReason = 'WE_ARE_TOO_BUSY';
        this.state.orderProblemDetails = '';
        this.state.isCancelOrderExpanded = false;
        this.state.resendOrderConfirmationModalOpened = false;
        this.state.resetOrderId = null;
        this.state.rejectedOrderStatusReceived = null;
        this.state.loading = false;
    }

    reportOrderProblem(e, selectedOrder) {
        e.preventDefault();

        const orderId = selectedOrder.id;
        const data = {
            attachments: [],
            subject: `${i18n.t('screens:orderDetailsScreen.orderSupport')}: #${orderId}`,
            body: this.state.orderProblemDetails
        };

        this.props.createTicket(data, () => {
            this.toggle();
        });
    }

    doRefund() {
        const orderId = this.props.orderDetails.order.id;
        const refundData = {
            amount: (this.state.refundValue == 0 || this.state.refundValue == null) ? null : Number(this.state.refundValue),
            reason: this.state.refundReason,
            refundType: 'CREDIT_CARD'
        };
        const restaurantId = this.props.restaurantId;
        const currentPageNumber = this.props.currentPageNumber;

        this.props.refund(refundData, orderId, restaurantId, currentPageNumber, () => {
            this.toggle();

            if (this.props.searchQuery) {
                this.props.getOrdersCentral(0, this.props.searchQuery);
            }
        });
    }

    doRefundGiftCard() {
        const orderId = this.props.orderDetails.order.id;
        const refundData =
            {
                amount: (this.state.refundGiftCardValue == 0 || this.state.refundGiftCardValue == null) ? null : Number(this.state.refundGiftCardValue),
                reason: this.state.giftCardRefundReason,
                giftCardId: this.state.cardId
            };

        const restaurantId = this.props.restaurantId;
        const currentPageNumber = this.props.currentPageNumber;
        
        this.props.refundGiftCard(refundData, orderId, restaurantId, currentPageNumber, () => {
            this.toggle();

            if (this.props.searchQuery) {
                this.props.getOrdersCentral(0, this.props.searchQuery);
            }
        });
    }

    cancelOrder() {
        const cancelReason = this.state.cancelRefundReason;
        const orderId = this.props.orderDetails.order.id;
        const restaurantId = this.props.restaurantId;
        const currentPageNumber = this.props.currentPageNumber;

        this.props.cancelOrder(cancelReason, orderId, restaurantId, currentPageNumber, () => {
            this.toggle();

            if (this.props.searchQuery) {
                this.props.getOrdersCentral(0, this.props.searchQuery);
            }
        });
    }

    renderCustomerDetails() {
        const customer = this.props.orderDetails.order.customer;

        return (
            <DetailsCard
                header={i18n.t('screens:orderDetailsScreen.customerDetails')}
                name={customer.name}
                phone={customer.phone}
                email={customer.email}
                location={customer.countryCode === CA || customer.countryCode === US ? i18n.t('common:languages.northAmerica') : localizeCountryNames(customer.countryCode)}
                iconType='person'
                styles={styles}
                nameLinkTo={`/restaurant/${this.props.restaurantId}/customer-insight/${customer.id}`}
            />
        );
    }

    renderRestaurantDetails() {
        const restaurant = this.props.orderDetails.restaurantDetails;
        const restaurantAddress = restaurant.address;
        const address = (restaurant.displayAddress !== null) ? restaurant.displayAddress : restaurantAddress.street + ', ' + restaurantAddress.city + ', ' + localizeCountryNames(restaurantAddress.country);

        if (Object.keys(this.props.orderDetails.restaurantDetails).length > 0) {

            return (
                <DetailsCard
                    header={i18n.t('screens:orderDetailsScreen.restaurantDetails')}
                    name={restaurant.name}
                    phone={restaurant.phone}
                    email={restaurant.email}
                    location={address}
                    iconType='restaurant_menu'
                    styles={styles}
                />
            );
        }
    }

    renderReportProblem() {
        const { cancelOrderContainer, noPadding, alignInRow, reportProblemButton, problemDetailsLabel } = styles;
        const { order } = this.props.orderDetails;

        return (
            <Row>
                <Col xs={12} sm={12} md={12} style={cancelOrderContainer} >
                    <OrderDetailsIcon
                        styles={styles}
                        iconType='headset_mic'
                        textContent={i18n.t('screens:orderDetailsScreen.contactSupport')}
                    />
                    <AvForm onValidSubmit={(e) => this.reportOrderProblem(e, order)}>
                        <Card>
                            <CardBody>
                                <Col xs={12} sm={12} style={Object.assign({}, noPadding, alignInRow)}>
                                    <Label md={1} sm={1} for="orderProblemDetails" style={problemDetailsLabel}>{i18n.t('screens:orderDetailsScreen.problemDetails')}</Label>
                                    <AvGroup style={{ width: '80%' }} >
                                        <AvInput type="text" name="orderProblemDetails" id="orderProblemDetails"
                                            value={this.state.orderProblemDetails}
                                            onChange={this.changeState}
                                            required={true} />
                                        <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                                    </AvGroup>
                                    <Button color="primary" style={reportProblemButton}>{i18n.t('common:buttons.send')}</Button>
                                </Col>
                            </CardBody>
                        </Card>
                    </AvForm>
                </Col>
            </Row>
        );
    }

    renderOrderDetails() {
        return (
            <Row>
                {/* <Button
                    color='primary'
                    onClick={() => this.props.getPosOrderData(this.props.orderDetails.order.id)}
                    >
                    <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                        <MaterialIcon icon="cloud_download" color="#fff" size={19} />
                        <span style={{ marginLeft: 6 }}>{i18n.t('screens:centralOrdersLog.download')}</span>
                    </div>
                </Button> */}
                <Col xs={12} sm={12} md={12}>
                    <OrderDetailsIcon
                        styles={styles}
                        iconType='shopping_cart'
                        textContent={i18n.t('screens:orderDetailsScreen.orderDetails')}
                    />
                    <OrderDetailsTable
                        {...this.props}
                        styles={styles}
                    />
                </Col>
            </Row>
        );
    }

    renderProductsDetails() {
        return (
            <Row>
                <Col xs={12} sm={12} md={12}>
                    <OrderDetailsIcon
                        styles={styles}
                        iconType='shopping_cart'
                        textContent={i18n.t('screens:orderDetailsScreen.productDetails')}
                    />
                    <ProductsDetailsTable
                        {...this.props}
                        styles={styles}
                    />
                </Col>
            </Row>
        );
    }

    renderRefundDetails() {
        const { refundDetailsContainer, negativeMarginRight, noLeftRightMargin, totalPriceContainer, totalPriceLabel, refundTypeContainer, priceStyle,
            refundTypeLabel, refundValueContainer, refundValueLabel, refundReasonContainer, refundReasonColumn, refundReasonLabel } = styles;
        const { order } = this.props.orderDetails;
        const { refunds } = this.props.orderDetails;
        const orderTotal = order.total + (order.serviceFee ? order.serviceFee : 0);
        const currency = this.props.currency ? this.props.currency : this.props.orderDetails.order.currency;
        const maxRefundAmount = transformProductPrice(getMaxRefundAmount(orderTotal, refunds));
        const isRefundDisabled = (maxRefundAmount === 0 || (!this.state.refundValue && this.state.refundType === 'Part')) ? true : false;
        const isRefundHidden = (order.tenderType.id == CASH_ID || order.status == 'CANCELED' || order.status == 'REFUNDED' || maxRefundAmount == 0) ? true : false;
        const priceTotal = transformProductPrice(orderTotal);
        const priceTotalWithCurrency = getPriceWithCurrencySymbol(priceTotal, currency);
        const maxRefundAmountWithCurrency = getPriceWithCurrencySymbol(maxRefundAmount, currency);

        return (
            <Row>
                <Col xs={12} sm={12} md={12} style={refundDetailsContainer} hidden={isRefundHidden}>
                    <OrderDetailsIcon
                        styles={styles}
                        iconType='attach_money'
                        textContent={i18n.t('screens:orderDetailsScreen.refundDetails')}
                        hidden={isRefundHidden}
                    />
                    <Card style={negativeMarginRight}>
                        <CardBody style={negativeMarginRight}>
                            <Row style={noLeftRightMargin}>
                                <Col xs={12} sm={4} style={totalPriceContainer}>
                                    <p style={totalPriceLabel}>{order.loyaltyDiscount ? i18n.t('screens:orderDetailsScreen.priceLabelNoLoyalty') : i18n.t('screens:orderDetailsScreen.priceLabel')}:
                                        <span style={priceStyle}>
                                            {priceTotalWithCurrency}
                                        </span>
                                    </p>
                                </Col>
                                <Col xs={12} sm={4} style={refundTypeContainer}>
                                    <span style={refundTypeLabel}>{i18n.t('screens:orderDetailsScreen.refundType')}: </span>
                                    <Input type="select" name="refundType" id="refundType" placeholder={i18n.t('screens:orderDetailsScreen.refundType')}
                                        value={this.state.refundType}
                                        onChange={this.changeState}>
                                        <option value="Full">{i18n.t('screens:orderDetailsScreen.full')}</option>
                                        <option value="Part">{i18n.t('screens:orderDetailsScreen.part')}</option>
                                    </Input>
                                </Col>
                                <Col xs={12} sm={4} style={refundValueContainer}>
                                    <span style={refundValueLabel}>{i18n.t('screens:orderDetailsScreen.refundValue')}</span>
                                    <Input type="number" name="refundValue"
                                        placeholder={'up to ' + maxRefundAmountWithCurrency}
                                        max={maxRefundAmount}
                                        min={1}
                                        disabled={(this.state.refundType == 'Full') ? true : false}
                                        value={this.state.refundValue}
                                        onChange={this.changeState} />
                                </Col>
                            </Row>
                            <Row style={refundReasonContainer}>
                                <Col xs={12} sm={10} style={refundReasonColumn}>
                                    <span style={refundReasonLabel}>{i18n.t('screens:orderDetailsScreen.refundReason')}: </span>
                                    <Input type="textarea" name="refundReason" id="refundReason" placeholder={i18n.t('screens:orderDetailsScreen.typeRefundReason')}
                                        value={this.state.refundReason} onChange={this.changeState} required={true} />
                                </Col>
                                <Col xs={12} sm={2} >
                                    <Button color="primary" disabled={isRefundDisabled} onClick={() => this.doRefund()} style={{ paddingLeft: 10 }} >{i18n.t('screens:orderDetailsScreen.doRefund')}</Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        );
    }

    renderGiftCard() {
        const giftCards = this.props.orderDetails.order.paymentDetails ? this.props.orderDetails.order.paymentDetails.giftCards : null;
        if (giftCards !== null && giftCards !== undefined) {
            return giftCards.map((giftCards, i) => {
                return (<option key={i} id={i} value={giftCards.cardId}>{giftCards.cardId}</option>)
            });
        }  
    }

    getGiftCardAmounts(giftCards) {
        let giftCardsTotalAmount = 0;
        let giftCardsTotalRefundAmount = 0;
        
        if(giftCards) {
            for(let i = 0; i < giftCards.length; i++) {
                giftCardsTotalAmount += giftCards[i].amount
    
                if(giftCards[i].refundAmount) {
                    giftCardsTotalRefundAmount += giftCards[i].refundAmount;
                }
            }
            
            if(giftCardsTotalRefundAmount === giftCardsTotalAmount) {
                return true;
            } else {
                return false;
            }
        } else { 
            return false;
        }
    }

    renderGiftCardDetails() {
        const { refundDetailsContainer, negativeMarginRight, noLeftRightMargin, totalPriceContainer, totalPriceLabel, refundTypeContainer, priceStyle,
            refundTypeLabel, refundValueContainer, refundValueLabel, refundReasonContainer, refundReasonColumn, refundReasonLabel } = styles;
        const { order } = this.props.orderDetails;
        const { giftCardTotalDiscount, refundedGiftCardValue } = this.state;
        const { refunds } = this.props.orderDetails;
        const currency = this.props.currency ? this.props.currency : this.props.orderDetails.currency;
        const maxRefundAmount = transformProductPrice(this.state.giftCardTotalDiscount - this.state.refundedGiftCardValue);
        const maxRefundGiftCardAmount = giftCardTotalDiscount && refundedGiftCardValue ? `${giftCardTotalDiscount - refundedGiftCardValue}` : giftCardTotalDiscount && !refundedGiftCardValue ? giftCardTotalDiscount : '0.00';
        const maxRefundGiftCardAmountWithCurrency = getPriceWithCurrencySymbol(maxRefundGiftCardAmount, currency);
        const giftCards = this.props.orderDetails.order.paymentDetails ? this.props.orderDetails.order.paymentDetails.giftCards : null;
        const getGiftCardAmounts = this.getGiftCardAmounts(giftCards);
        const isRefundHidden = (!giftCards || order.status == 'CANCELED' || getGiftCardAmounts) ? true : false;
        const discount = this.state.giftCardTotalDiscount !== null && this.state.giftCardTotalDiscount !== undefined && this.state.giftCardTotalDiscount !== '' ? this.state.giftCardTotalDiscount : null;
        const discountWithCurrency = getPriceWithCurrencySymbol(discount, currency);
        const currencySymbol = getCurrencySymbol(currency);
        const isRefundButtonDisabled = (maxRefundAmount === 0 || discount < 5 || !this.state.refundGiftCardValue || this.state.refundGiftCardValue < 5) ? true : false;
        const isRefundInputDisabled = (maxRefundAmount === 0 || discount < 5 || maxRefundAmount < 5) ? true : false;
        
        return (
            <Row>
                <Col xs={12} sm={12} md={12} style={refundDetailsContainer} hidden={isRefundHidden}>
                    <OrderDetailsIcon
                        styles={styles}
                        iconType='card_giftcard'
                        textContent={i18n.t('screens:orderDetailsScreen.giftCardDetails')}
                        hidden={isRefundHidden}
                    />
                    <Card style={negativeMarginRight}>
                        <CardBody style={negativeMarginRight}>
                            <Row style={noLeftRightMargin}>
                                <Col xs={12} sm={4} style={totalPriceContainer}>
                                    <p style={totalPriceLabel}>{i18n.t('screens:orderDetailsScreen.totalGiftCardDiscount')}: 
                                        <span style={priceStyle}>
                                            {discountWithCurrency}
                                        </span>
                                    </p>
                                </Col>
                                <Col xs={12} sm={4} style={refundTypeContainer}>
                                    <span style={refundTypeLabel}>{i18n.t('screens:orderDetailsScreen.giftCards')}: </span>
                                    <Input type="select" name="cardId" id="cardId" placeholder={i18n.t('screens:orderDetailsScreen.selectGiftCard')}
                                        value={this.state.cardId}
                                        onChange={this.changeState}>
                                        <option value='' id={-1}>{i18n.t('screens:orderDetailsScreen.selectGiftCard')}</option>
                                        {this.renderGiftCard()}
                                    </Input>
                                </Col>
                                <Col xs={12} sm={4} style={refundValueContainer}>
                                    <span style={refundValueLabel}>{i18n.t('screens:orderDetailsScreen.refundValue')}</span>
                                    <Input type="number" name="refundGiftCardValue" id="refundGiftCardValue"
                                        placeholder={maxRefundAmount < 5 ? '' : 'up to ' + maxRefundGiftCardAmountWithCurrency}
                                        max={maxRefundAmount}
                                        min={1}
                                        value={this.state.refundGiftCardValue}
                                        disabled={isRefundInputDisabled}
                                        onChange={this.changeState} />
                                </Col>
                                <Col style={{marginBottom: '10px'}}><p style={{color: 'grey', fontSize: 13, position: 'absolute', right: '1.5em'}}>{i18n.t('screens:orderDetailsScreen.giftCardMinRefundValueMessage')}{currencySymbol}.</p></Col>
                            </Row>
                            <Row style={refundReasonContainer}>
                                <Col xs={12} sm={10} style={refundReasonColumn}>
                                    <span style={refundReasonLabel}>{i18n.t('screens:orderDetailsScreen.refundReason')}: </span>
                                    <Input type="textarea" name="giftCardRefundReason" id="giftCardRefundReason" placeholder={i18n.t('screens:orderDetailsScreen.typeRefundReason')}
                                        value={this.state.giftCardRefundReason} onChange={this.changeState} required={true} />
                                </Col>
                                <Col xs={12} sm={2} >
                                    <Button color="primary" disabled={isRefundButtonDisabled} onClick={() => this.doRefundGiftCard()} style={{ paddingLeft: 10 }} >{i18n.t('screens:orderDetailsScreen.doRefund')}</Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        );
    }


    renderRefundHistoryDetails() {
        const order = this.props.orderDetails.order;
        const isRefundHistoryHidden = (order.tenderType.id == CASH_ID && !order.giftCardDiscount) ? true : false;
        
        return (
            <Row>
                <Col xs={12} sm={12} md={12} style={{ paddingLeft: 0, marginBottom: 15 }} hidden={isRefundHistoryHidden}>
                    <OrderDetailsIcon
                        styles={styles}
                        iconType='history'
                        textContent={i18n.t('screens:orderDetailsScreen.refundHistory')}
                        hidden={isRefundHistoryHidden}
                    />
                    <RefundHistoryTable
                        {...this.props}
                    />
                </Col>
            </Row>
        );
    }

    renderCancelOrder() {
        const { cancelOrderContainer, cardBodyMainColumn, cancelRefundReasonColumn, leftAlignedLabel, noPadding, cancelOrderButton } = styles;
        const order = this.props.orderDetails.order;
        const isCancelOrderHidden = (order.status == 'CANCELED') ? true : false;

        return (
            <Row>
                <Col xs={12} sm={12} md={12} style={cancelOrderContainer} hidden={isCancelOrderHidden}>
                    <OrderDetailsIcon
                        styles={styles}
                        iconType='clear'
                        textContent={i18n.t('screens:orderDetailsScreen.cancelOrder')}
                        hidden={isCancelOrderHidden}
                    />
                    <Card>
                        <CardBody>
                            <Col xs={12} sm={12} style={cardBodyMainColumn}>
                                <Col sm={7} style={cancelRefundReasonColumn}>
                                    <p style={leftAlignedLabel}>{i18n.t('screens:orderDetailsScreen.cancelReason')}:</p>
                                    <Input type="select" name="cancelRefundReason" id="cancelRefundReason"
                                        value={this.state.cancelRefundReason}
                                        onChange={this.changeState}>
                                        <option value="WE_ARE_TOO_BUSY">{i18n.t('screens:orderDetailsScreen.tooBusyMsg')}</option>
                                        <option value="DELIVERY_NOT_AVAILABLE_AT_THIS_TIME">{i18n.t('screens:orderDetailsScreen.deliveryNotAvailableMsg')}</option>
                                        <option value="NOT_WITHIN_DELIVERY_AREA">{i18n.t('screens:orderDetailsScreen.notWithinDeliveryAreaMsg')}</option>
                                        <option value="PRODUCTS_UNAVAILABLE">{i18n.t('screens:orderDetailsScreen.productsUnavailableMsg')}</option>
                                        <option value="EQUIPMENT_FAILURE">{i18n.t('screens:orderDetailsScreen.equipmentFailureMsg')}</option>
                                        <option value='CANCELED_BY_STORE'>{i18n.t('screens:orderDetailsScreen.canceledByStore')}</option>
                                        <option value='CANCELED_BY_CUSTOMER'>{i18n.t('screens:orderDetailsScreen.canceledByCustomer')}</option>
                                    </Input>
                                </Col>
                                <Col sm={2} style={noPadding}>
                                    <Button color="primary" onClick={() => this.cancelOrder()} style={cancelOrderButton}>{i18n.t('screens:orderDetailsScreen.cancelOrder')}</Button>
                                </Col>
                            </Col>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        );
    }

    renderResetButtonLoader() {
        if (!this.state.loading) return null;

        return (
            <div style={styles.loadingContainerTransparent}>
                    <div style={styles.loadingIndicator} className='text-center loadingIndicator'>
                        <GridLoader color="#0288d1" size={20} />
                    </div>
                </div>
        );
    }

    resendOrder(orderId) {
        this.setState({ ...this.state, loading: true }, () => {

            this.props.resendFailedOrder(orderId, (orderStatus) => {
                if (orderStatus) {
                    this.setState({ ...this.state, rejectedOrderStatusReceived: orderStatus, loading: false }, () => this.toggleResendOrderConfirmationModal());
                    this.props.rejectedOrderReseted();
                } else {
                    this.setState({ ...this.state, loading: false }, () => this.toggleResendOrderConfirmationModal());
                }
            });
        });
    }

    acceptOrder(orderId) {
        this.setState({ ...this.state, loading: true }, () => {

            this.props.manuallyAcceptOrder(orderId, () => {
                this.setState({ ...this.state, loading: false }, () => this.toggleAcceptOrderConfirmationModal());
                this.props.refreshResults();
                this.props.getOrdersDetails(orderId);
            });
        });
    }

    toggleResendOrderConfirmationModal(orderId) {
        this.setState({
            ...this.state,
            resendOrderConfirmationModalOpened: !this.state.resendOrderConfirmationModalOpened,
            resetOrderId: (orderId) ? orderId : null
        });
    }

    renderResendOrderConfirmation() {
        return (
            <ConfirmationModal
                isOpen={this.state.resendOrderConfirmationModalOpened}
                toggle={this.toggleResendOrderConfirmationModal.bind(this)}
                title={i18n.t('screens:orderDetailsScreen.resetOrderModalTitle')}
                message={i18n.t('screens:orderDetailsScreen.resetOrderModalMessage')}
                disabled={this.state.loading}
                onClick={this.resendOrder.bind(this, this.state.resetOrderId)}
                loader={this.renderResetButtonLoader.bind(this)}
            />
        );
    }

    toggleAcceptOrderConfirmationModal(orderId) {
        this.setState({
            ...this.state,
            acceptOrderConfirmationModalOpened: !this.state.acceptOrderConfirmationModalOpened,
            acceptOrderId: (orderId) ? orderId : null
        });
    }

    renderAcceptOrderConfirmation() {
        return (
            <ConfirmationModal
                isOpen={this.state.acceptOrderConfirmationModalOpened}
                toggle={this.toggleAcceptOrderConfirmationModal.bind(this)}
                title={i18n.t('screens:orderDetailsScreen.acceptOrderModalTitle')}
                message={i18n.t('screens:orderDetailsScreen.acceptOrderModalMessage')}
                disabled={this.state.loading}
                onClick={this.acceptOrder.bind(this, this.state.acceptOrderId)}
                loader={this.renderResetButtonLoader.bind(this)}
            />
        );
    }

    renderExtraTimeInput() {
        return (
            <div style={{ display: 'flex', marginLeft: 10 }}>
                <Input type="select" name="extraTime" id="extraTime"
                    value={this.state.extraTime}
                    onChange={(e) => this.setState({ ...this.state, [e.target.name]: e.target.value })}>
                    {this.renderExtraTimeOptions()}
                </Input>
                <Button color="primary" onClick={this.onClickAddExtraTime} style={{ marginLeft: 5 }}>{i18n.t('screens:orderDetailsScreen.add')}</Button>
            </div>
        )
    }

    renderExtraTimeOptions() {
        let minutes = []
        for (let i = 5; i <= 40; i += 5) {
            minutes.push(i);
        }

        return minutes.map(minute => <option value={minute}>{`${minute} minutes`}</option>)
    }

    onClickAddExtraTime() {
        this.props.addExtraTime(this.props.orderDetails.order.id, this.state.extraTime);
        this.setState({ ...this.state, addExtraTime: false });
    }

    renderOrderTypeStringContent(orderTypeId) {
        switch (orderTypeId) {
            case COLLECTION_ID:
                return i18n.t('screens:restaurantsMainContainer.collection');
            case DELIVERY_ID:
                return i18n.t('screens:restaurantsMainContainer.delivery');
            case INSTORE_ID:
                return i18n.t('screens:restaurantsMainContainer.instore');
            case CURBSIDE_ID:
                return i18n.t('screens:restaurantsMainContainer.curbside');
            default:
                return
        }
    }

    renderOrderInfo() {
        const { labelStyle, spanStyle, orderTypeIcon, paymentTypeIcon, alignInRow } = styles;

        const { order } = this.props.orderDetails;
        let orderStatus = (order.status !== null) ? i18n.t(`screens:orderHistoryScreen.${order.status.toLowerCase()}`) : i18n.t(`screens:orderHistoryScreen.noStatus`);

        if (this.state.rejectedOrderStatusReceived) orderStatus = i18n.t(`screens:orderHistoryScreen.${this.state.rejectedOrderStatusReceived.toLowerCase()}`);

        let orderStatusColor = RestaurantUtils.getOrderStatusColor(order.status);

        if (this.state.rejectedOrderStatusReceived) orderStatusColor = RestaurantUtils.getOrderStatusColor(this.state.rejectedOrderStatusReceived);

        const customer = order.customer;

        const orderAddress = order.orderAddress;
        const address = (orderAddress.fullAddress !== null) ? orderAddress.fullAddress : orderAddress.street + ', ' + orderAddress.city + ', ' + localizeCountryNames(orderAddress.country)
        const orderAddressInfo = order.orderType.id === INSTORE_ID ? order.orderInStoreInfo.value : order.orderType.id === CURBSIDE_ID ? order.carDetails : address;
        const collectionAddress = i18n.t('screens:orderDetailsScreen.collectionAddress');
        const deliveryAddress = i18n.t('screens:orderDetailsScreen.deliveryAddress');
        let orderAddressText = (order.orderType.id == COLLECTION_ID) ? collectionAddress : (order.orderType.id == DELIVERY_ID) ? deliveryAddress : '';
        if (order.orderType.id === INSTORE_ID) {
            orderAddressText = `${order.orderInStoreInfo.label}: `;
        }

        const orderTypeIconStyle = this.renderOrderTypeIconStyle(order.orderType.id);
        const orderTypeIconSrc = renderOrderTypeSrc(order.orderType.id, orderTypeIconStyle);
        const orderTypeValue = order.orderType.value.replace(/\s/g, '');

        const paymentTypeIconStyle = this.renderPaymentTypeIconStyle(order.tenderType.id);
        let paymentTypeIconSrc = renderPaymentTypeIcon(order.tenderType.id, paymentTypeIconStyle);
        const paymentTypeValue = order.tenderType.value.replace(/\s/g, '');

        const orderServiceFee = order.serviceFee ? order.serviceFee : 0;
        let price = parseFloat(order.total) + orderServiceFee;

        let renderLoyaltyIcon = order.paidWithVoucher;

        const loyaltyIconStyle = this.renderPaymentTypeIconStyle(3);
        const isOnlyLoyalty = renderLoyaltyIcon && price === 0 ? true : false;
        
        if (isOnlyLoyalty) {
            paymentTypeIconSrc = null;
        }

        const loyaltyIconSrc = renderPaymentTypeIcon(3, loyaltyIconStyle, isOnlyLoyalty); // Loyalty fake id
        const isGiftCardDiscount = order.giftCardDiscount ? true : false;
        const currUserRole = localStorage.getItem('role');

        return (
            <Row>
                <Col xs={6} sm={6} md={6}>
                    <p style={labelStyle}>
                        {i18n.t('screens:orderHistoryScreen.orderIdTable')}
                        <span style={spanStyle}> {order.id}</span>
                    </p>
                    <p style={labelStyle}>{i18n.t('screens:orderDetailsScreen.orderStatus')}
                        <span style={{ color: orderStatusColor }}>{orderStatus}</span>
                        <Button
                            style={{ marginLeft: 10 }}
                            color="primary"
                            hidden={orderStatus.toUpperCase() !== REJECTED || this.props.orderDetails.order.deleted}
                            onClick={this.toggleResendOrderConfirmationModal.bind(this, order.id)}>
                            {i18n.t('screens:orderDetailsScreen.resendOrder')}
                        </Button>
                        <Button
                            style={{ marginLeft: 10 }}
                            color="primary"
                            hidden={orderStatus.toUpperCase() !== REJECTED || this.props.orderDetails.order.deleted}
                            onClick={this.toggleAcceptOrderConfirmationModal.bind(this, order.id)}>
                            {i18n.t('screens:orderDetailsScreen.acceptOrder')}
                        </Button>
                    </p>
                    <p style={labelStyle}>{i18n.t('screens:orderDetailsScreen.orderType')}
                        <span style={{ padding: 8 }}>
                            {orderTypeIconSrc}
                            <span style={spanStyle}>{i18n.t(`screens:orderDetailsScreen.${orderTypeValue}`)}</span>
                        </span>
                    </p>
                    <p style={{ ...labelStyle, display: 'flex', alignItems: 'center' }}><span style={{ marginRight: 4 }}>{i18n.t('screens:orderDetailsScreen.dateTime')}:</span>
                        <span style={spanStyle}>{order.wantedTime}</span>
                        {console.log('orderStatus', orderStatus.toUpperCase())}
                        <Button
                            style={{ marginLeft: 10 }}
                            color="primary"
                            hidden={((orderStatus.toUpperCase() !== ACCEPTED && orderStatus.toUpperCase() !== ACEPTADO) && !this.state.addExtraTime) || this.state.addExtraTime}
                            onClick={() => this.setState({ ...this.state, addExtraTime: true })}>
                            {i18n.t('screens:orderDetailsScreen.addExtraTime')}
                        </Button>
                        {this.state.addExtraTime ? this.renderExtraTimeInput() : null}
                    </p>
                    {
                        order.rejectReason ?
                            <p style={labelStyle}>
                                {i18n.t('screens:orderDetailsScreen.rejectReason')}:
                                <span style={spanStyle}> {i18n.t(`screens:mainContainer.${order.rejectReason}`)}</span>
                            </p> : null
                    }
                    <p style={labelStyle}>{i18n.t('screens:orderHistoryScreen.source')}: <span style={spanStyle}><OrderSourceSelector source={order.source} /></span></p>
                </Col>
                <Col xs={6} sm={6} md={6}>
                    <p style={labelStyle}>{i18n.t('screens:orderHistoryScreen.customerName')}:
                        <span style={spanStyle}> {customer.name}</span>
                    </p>
                    <p style={labelStyle}>{orderAddressText}
                        <span style={spanStyle}> {orderAddressInfo}</span>
                    </p>
                    <p style={labelStyle}>{i18n.t('screens:orderDetailsScreen.paymentType')}
                        {renderLoyaltyIcon && paymentTypeIconSrc && !isGiftCardDiscount ?
                            <React.Fragment>
                                <span style={spanStyle}>{paymentTypeIconSrc}</span>
                                <span style={spanStyle}>{i18n.t(`screens:orderDetailsScreen.${paymentTypeValue}`)}</span>
                                <span style={spanStyle}> + </span>
                                {loyaltyIconSrc}
                                <span style={spanStyle}> {i18n.t('screens:restaurantsMainContainer.loyalty')}</span>
                            </React.Fragment> :
                            renderLoyaltyIcon && !paymentTypeIconSrc && !isGiftCardDiscount ?
                                <React.Fragment>
                                    {loyaltyIconSrc}
                                    <span style={spanStyle}> {i18n.t('screens:restaurantsMainContainer.loyalty')}</span>
                                </React.Fragment>
                                :
                                paymentTypeIconSrc ?
                                <React.Fragment>
                                    <span>{paymentTypeIconSrc}</span>
                                    <span style={spanStyle}>{i18n.t(`screens:orderDetailsScreen.${paymentTypeValue}`)}</span>
                                </React.Fragment> : null
                        } 
                        {isGiftCardDiscount && renderLoyaltyIcon && paymentTypeIconSrc ? 
                                <React.Fragment>
                                    <span style={spanStyle}> + </span>
                                    {loyaltyIconSrc}
                                    <span style={spanStyle}> {i18n.t('screens:restaurantsMainContainer.loyalty')}</span>
                                    <span style={spanStyle}> + </span>
                                    <span style={{position: 'relative', top: -1}}><MaterialIcon icon="card_giftcard" size={28} width={24} height={26} color='#0288d1' /></span> 
                                    <span style={spanStyle}>{i18n.t('screens:orderHistoryScreen.giftCard')}</span>
                                </React.Fragment>
                                :
                                isGiftCardDiscount && renderLoyaltyIcon ?
                                <React.Fragment>
                                    {loyaltyIconSrc}
                                    <span style={spanStyle}> {i18n.t('screens:restaurantsMainContainer.loyalty')}</span>
                                    <span style={spanStyle}> + </span>
                                    <span style={{position: 'relative', top: -1}}><MaterialIcon icon="card_giftcard" size={28} width={24} height={26} color='#0288d1' /></span> 
                                    <span style={spanStyle}>{i18n.t('screens:orderHistoryScreen.giftCard')}</span>
                                </React.Fragment>
                                :
                                isGiftCardDiscount && paymentTypeIcon ? 
                                <React.Fragment>
                                    <span style={spanStyle}> + </span>
                                    <span style={{position: 'relative', top: -1}}><MaterialIcon icon="card_giftcard" size={28} width={24} height={26} color='#0288d1' /></span> 
                                    <span style={spanStyle}>{i18n.t('screens:orderHistoryScreen.giftCard')}</span>
                                </React.Fragment> : null
                        }
                    </p>
                    <p style={{ ...labelStyle, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            color="primary"
                            onClick={() => this.props.getOrderAsPdf(this.props.orderDetails.order.id)}>
                            {i18n.t('screens:orderDetailsScreen.printOrder')}
                        </Button>
                    </p>
                    { (currUserRole === MENUU_MASTER_ADMIN || currUserRole === MENUU_ADMIN) ?
                        <p style={{ ...labelStyle, display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                color='primary'
                                onClick={() => this.props.downloadPosOrderData(this.props.orderDetails.order.id)}
                            >
                                <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                                    <MaterialIcon icon="cloud_download" color="#fff" size={19} />
                                    <span style={{ marginLeft: 6 }}>{i18n.t('screens:orderDetailsScreen.posOrderData')}</span>
                                </div>
                            </Button>
                        </p> : null
                    }   
                </Col>
            </Row>
        )
    }

    renderOrderTypeIconStyle(orderTypeId) {
        if (orderTypeId) {
            switch (orderTypeId) {
                case DELIVERY_ID:
                    return ({ position: 'relative', top: 7, right: 5 })
                    break;
                case CURBSIDE_ID:
                    return ({ position: 'relative', top: 7, right: 3 })
                    break;
                case COLLECTION_ID:
                    return ({ position: 'relative', top: 5, right: 2 })
                    break;
                case INSTORE_ID:
                    return ({ position: 'relative', top: 5, right: 2 })
                    break;
                default:
                    return {}
            }
        } else {
            return {}
        }

    }

    renderPaymentTypeIconStyle(paymentTypeId) {

        if (paymentTypeId) {
            switch (paymentTypeId) {
                case 1:
                    return ({ position: 'relative', top: 5, left: 3 })
                    break;
                case 2:
                    return ({ position: 'relative', top: 5, left: 4 })
                    break;
                case 3:
                    return ({ position: 'relative', top: 8, left: 4 })
                    break;
                default:
                    return {}
            }
        } else {
            return {}
        }

    }

    renderCustomerAndRestaurantDetails() {
        return (
            <Row style={{ marginBottom: 20 }}>
                {this.renderCustomerDetails()}
                {this.renderRestaurantDetails()}
            </Row>
        )
    }

    renderModalBody() {
        const { modalBodyContainer } = styles;

        if (this.props.orderDetails !== undefined && this.props.orderDetails !== null && Object.keys(this.props.orderDetails.order).length > 0) {
            return (
                <ModalBody style={modalBodyContainer}>
                    {
                        this.props.orderDetails.order.deleted ?
                            <Row>
                                <Col>
                                    <p>* {i18n.t('screens:orderHistoryScreen.containsDelProducts')}</p>
                                </Col>
                            </Row> : null
                    }
                    {this.renderOrderInfo()}
                    {this.renderCustomerAndRestaurantDetails()}
                    {this.renderProductsDetails()}
                    {this.renderOrderDetails()}
                    {this.renderRefundDetails()}
                    {this.renderGiftCardDetails()}
                    {this.renderRefundHistoryDetails()}
                    {this.renderCancelOrder()}
                    {this.renderReportProblem()}
                    {this.renderResendOrderConfirmation()}
                    {this.renderAcceptOrderConfirmation()}
                </ModalBody>
            );
        }
    }

    render() {
        return (
            <div>
                <Modal className="orderInformationModal" isOpen={this.props.isOpen} size="lg" style={{ maxWidth: '1200px' }}>
                    <ModalHeader className="modalHeader"
                        toggle={this.toggle}>{i18n.t('screens:orderDetailsScreen.order')}</ModalHeader>
                    {this.renderModalBody()}
                </Modal>
            </div>
        );
    }
}

export default connect(null, { refund, refundGiftCard, cancelOrder, clearSelectedOrder, createTicket, resendFailedOrder, manuallyAcceptOrder, getOrdersDetails, addExtraTime, getOrderAsPdf, downloadOrderData, downloadPosOrderData })(OrderDetailsScreen);

let styles = {
    screenTitleContainer: {
        borderBottom: 1,
        borderBottomStyle: 'solid',
        borderBottomColor: 'blue',
        alignSelf: 'flex-start',
        borderColor: 'rgb(222, 226, 230)',
        paddingLeft: 0,
        marginTop: 15,
        marginBottom: 5,
        color: '#0288d1'
    },
    modalBodyContainer: { maxHeight: 600, overflow: 'auto' },
    labelStyle: { color: 'grey' },
    spanStyle: { color: '#000', padding: 5 },
    cancelOrderContainer: { paddingLeft: 15, paddingRight: 15, marginBottom: 15 },
    cardBodyMainColumn: { paddingLeft: 0, display: 'flex' },
    cancelRefundReasonColumn: { paddingLeft: 0, paddingRight: 0, display: 'flex' },
    leftAlignedLabel: { color: 'grey', paddingTop: 10, width: '40%' },
    noPadding: { padding: 0 },
    cancelOrderButton: { marginLeft: 20 },
    orderTypeIcon: { marginBottom: 5, marginLeft: 10, marginRight: 5 },
    paymentTypeIcon: { marginBottom: 6, marginLeft: 10, marginRight: 5 },
    textAlignCenter: { textAlign: 'center' },
    refundDetailsContainer: { paddingLeft: 0, marginBottom: 15, marginRight: -15 },
    negativeMarginRight: { marginRight: -15 },
    noLeftRightMargin: { marginLeft: 0, marginRight: 0 },
    totalPriceContainer: { paddingLeft: 0, paddingRight: 0 },
    totalPriceLabel: { color: 'grey', paddingTop: 10 },
    refundTypeContainer: { paddingLeft: 0, display: 'flex', marginLeft: -10, marginRight: 10 },
    priceStyle: { color: '#000', marginLeft: 10 },
    instructionsStyle: { color: 'grey', fontSize: 14, marginBottom: 2 },
    refundTypeLabel: { color: 'grey', paddingTop: 10, width: '100%' },
    refundValueContainer: { paddingLeft: 0, display: 'flex' },
    refundValueLabel: { color: 'grey', paddingTop: 10, width: '100%' },
    refundReasonContainer: { marginLeft: 0, marginRight: 0, marginTop: 20 },
    refundReasonColumn: { paddingLeft: 0, paddingRight: 0, display: 'flex' },
    refundReasonLabel: { color: 'grey', paddingTop: 10, width: '30%' },
    discountTh: { fontSize: '15.5px', position: 'relative', top: 1 },
    alignInRow: {
        marginTop: 10,
        display: 'flex',
        flexDirection: 'row'
    },
    problemDetailsLabel: {
        padding: '10px 0px',
        color: 'grey'
    },
    reportProblemButton: {
        marginLeft: 12
    },
    loadingIndicator: {
        width: '72px',
        height: '72px',
    },
    loadingContainerTransparent: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        textAlign: 'center',
        verticalAlign: 'middle',
        zIndex: 100000000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/orders/OrderDetailsScreen.js